enum JobFeeSource {
	RateCard = 1
}

export default JobFeeSource;